import { TextDomTag } from 'client/widget-components/basicComponents/Text';
import BaseCharCounter from 'client/widget-components/components/TextField/components/BaseCharCounter';
import { ResponsiveStylesProp } from 'client/widget-components/responsive-styles/responsiveStylesService';
import React from 'react';
import { CUSTOMIZATIONS_DATA_GRABS } from '../../constants';
import BaseProductCustomizationLabel from '../BaseProductCustomizationLabel';

interface TextFieldCustomizationLabelProps {
    label: string;
    valueLength: number;
    maxLength: number;
    required?: boolean;
    styles: {
        inputLabel?: ResponsiveStylesProp;
        inputCharacterCounter?: ResponsiveStylesProp;
    };
}

const TextFieldCustomizationLabel = ({
    styles,
    label,
    required,
    valueLength,
    maxLength,
}: TextFieldCustomizationLabelProps) => (
    <BaseProductCustomizationLabel
        label={label}
        required={required}
        styles={styles.inputLabel}
        dataGrab={CUSTOMIZATIONS_DATA_GRABS.textFieldLabelDataGrab}
        dataAuto='product-customizations-text-field-label'
    >
        <BaseCharCounter
            valueLength={valueLength}
            maxLength={maxLength}
            tag={TextDomTag.span}
            styles={styles.inputCharacterCounter}
            dataGrab={CUSTOMIZATIONS_DATA_GRABS.counterDataGrab}
            dataAuto='product-customizations-text-field-counter'
        />
    </BaseProductCustomizationLabel>
);

export default TextFieldCustomizationLabel;
